import React from 'react'
import { Stack, Box, Text } from '@chakra-ui/react'
interface BasicDetailsProps {
  transferAmount: string
  fromAccount: string
  toAccount: string
  totalBalanceChecked?: boolean
  isThirdParty?: boolean
}

export const BasicDetails = ({
  transferAmount,
  fromAccount,
  toAccount,
  totalBalanceChecked,
  isThirdParty
}: BasicDetailsProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3' className='test-id-header-2'>
        Transfer Details
      </Text>
      <Stack spacing={9}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='transferType'>
            <Text fontWeight='bold'>Transfer Type</Text>
            <Text className='test-id-transfer-type'>Cash Journal ({isThirdParty ? 'Third-Party' : 'First-Party'})</Text>
          </Box>
          <Box w='50%' data-testid='transferAmount'>
            <Text fontWeight='bold'>Transfer Amount</Text>
            <Text className='test-id-transfer-amount'>{totalBalanceChecked ? 'Total Balance' : transferAmount}</Text>
          </Box>
        </Stack>
        <Stack direction='column' w='100%' spacing={4}>
          <Box w='50%' data-testid='fromAccount'>
            <Text fontWeight='bold'>From Account</Text>
            <Text className='test-id-from-account'>{fromAccount}</Text>
          </Box>
          <Box w='50%' data-testid='toAccount'>
            <Text fontWeight='bold'>To Account</Text>
            <Text className='test-id-to-account'>{toAccount}</Text>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}
